<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <div
        id="idTable"
        style="overflow-x: auto;"
      >
        <table
          style="width: 100%; color: black; border-collapse: collapse;"
          class="elevation-1"
        >
          <thead>
            <tr>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
              />
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('supervisor')"
              >
                Supervisor
                <v-icon small>
                  {{ ordenarDados === 'supervisor' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('quantidadeOrdenacao')"
              >
                Quantidade
                <v-icon small>
                  {{ ordenarDados === 'quantidadeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('faturamentoOrdenacao')"
              >
                Faturamento
                <v-icon small>
                  {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('volumeOrdenacao')"
              >
                Volume (L)
                <v-icon small>
                  {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('cmvOrdenacao')"
              >
                CMV
                <v-icon small>
                  {{ ordenarDados === 'cmvOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemBrutaOrdenacao')"
              >
                Margem Bruta R$
                <v-icon small>
                  {{ ordenarDados === 'margemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemPorcentagemBrutaOrdenacao')"
              >
                Margem Bruta %
                <v-icon small>
                  {{ ordenarDados === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
              <th
                id="dadoMovimentacaoHeader"
                style="text-align: center;"
                @click="mudarOrdenacao('margemContribuicaoOrdenacao')"
              >
                Margem Contribuição %
                <v-icon small>
                  {{ ordenarDados === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                </v-icon>
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in faturamentoGrupoProdutos"
            :key="item.id"
          >
            <!-- Linha principal -->
            <tr>
              <td style="text-align: center;">
                <button @click="toggleExpand(index)">
                  {{ expanded.includes(index) ? '▲' : '▼' }}
                </button>
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: left;"
              >
                {{ item.supervisor }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.quantidade }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.faturamento }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.volume }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.cmv }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemPorcentagemBruta }}
              </td>
              <td
                id="dadoMovimentacao"
                style="text-align: right;"
              >
                {{ item.margemContribuicao }}
              </td>
            </tr>
            <!-- Linha expandida -->
            <tr
              v-if="expanded.includes(index)"
              :key="'expanded-' + item.id"
            >
              <td colspan="11">
                <table
                  id="tableExpandida"
                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('vendedor', index)"
                      >
                        Vendedor
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'vendedor' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('quantidadeOrdenacao', index)"
                      >
                        Quantidade
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'quantidadeOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('faturamentoOrdenacao', index)"
                      >
                        Faturamento
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'faturamentoOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('volumeOrdenacao', index)"
                      >
                        Volume (L)
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'volumeOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('cmvOrdenacao', index)"
                      >
                        CMV
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'cmvOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('margemBrutaOrdenacao', index)"
                      >
                        Margem Bruta R$
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'margemBrutaOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('margemPorcentagemBrutaOrdenacao', index)"
                      >
                        Margem Bruta %
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'margemPorcentagemBrutaOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('margemContribuicaoOrdenacao', index)"
                      >
                        Margem Contribuição %
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'margemContribuicaoOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoVendedores('prazoMedioOrdenacao', index)"
                      >
                        Prazo Médio Venda
                        <v-icon small>
                          {{ ordenarDadosVendedor === 'prazoMedioOrdenacao' ? (ordenacaoDadosVendedorDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(sub, idx) in item.dadosProduto"
                      :key="idx"
                      @click="detalheDadosPrazoMedio(sub)"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ sub.vendedor }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.quantidade }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.volume }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.cmv }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemPorcentagemBruta }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.margemContribuicao }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ sub.prazoMedio }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template>
        <v-dialog
          v-model="dialog.visible"
          transition="dialog-bottom-transition"
          persistent
          :max-width="dialog.width"
          content-class="custom-dialog-content"
          @keydown.esc="dialog.visible = false"
        >
          <v-card>
            <v-card-title>
              <v-spacer />
              <v-icon
                aria-label="Close"
                @click="dialog.visible = false, excluirPagina = true"
              >
                mdi-close
              </v-icon>
            </v-card-title>
            <v-card-text
              class="text-left"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="text-center"
                >
                  <div>
                    <h4>
                      Faturamento
                    </h4>
                    <h4>
                      {{ dialog.message }}
                    </h4>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text
              class="pb-3 pt-6 text-center"
              style="white-space: pre-line"
            >
              <div
                id="idTableDetalhe"
                style="overflow-x: auto;"
              >
                <table
                  style="width: 100%; color: black; border-collapse: collapse;"
                  class="elevation-1"
                  mobile-breakpoint="0"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoDetalhe('opcaoPagamento')"
                      >
                        Opção Pagamento
                        <v-icon small>
                          {{ ordenarDadosdetalhe === 'opcaoPagamento' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoDetalhe('faturamentoOrdenacao')"
                      >
                        Faturamento
                        <v-icon small>
                          {{ ordenarDadosdetalhe === 'faturamentoOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                        @click="mudarOrdenacaoDetalhe('participacaoOrdenacao')"
                      >
                        Participação Opção Pagamento (%)
                        <v-icon small>
                          {{ ordenarDadosdetalhe === 'participacaoOrdenacao' ? (ordenacaoDadosDetalheDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                        </v-icon>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in dadosDetalhe"
                      :key="item.id"
                    >
                      <td
                        id="dadoMovimentacaoDetalhe"
                        style="text-align: center;"
                      >
                        {{ item.opcaoPagamento }}
                      </td>
                      <td
                        id="dadoMovimentacaoDetalhe"
                        style="text-align: right;"
                      >
                        {{ item.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacaoDetalhe"
                        style="text-align: right;"
                      >
                        {{ item.participacao }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>

<script>
  import AnaliseMargem from '../../../../../services/analisemargem2'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      area: [],
      rede: [],
      supervisor: [],
      classificacao: [],
      linhasProducao: [],
      produtos: [],
      cidades: [],
      headersGrupoProdutos: [
        { text: 'Supervisor', value: 'supervisor', width: '20%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '10%', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Vendedor', value: 'vendedor', width: '20%', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Volume (l)', value: 'volume', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'CMV', value: 'cmv', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta R$', value: 'margemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Bruta %', value: 'margemPorcentatemBruta', align: 'right', width: '10%', class: 'black--text title' },
        { text: 'Margem Contribuição %', value: 'margemContribuicao', align: 'right', width: '10%', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      expanded: [],
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosVendedor: '',
      ordenacaoDadosVendedorDecrescente: false,
      ordenarDadosdetalhe: '',
      ordenacaoDadosDetalheDecrescente: false,
      faturamentoVendedor: 0,
      dadosDetalhe: [],
      dialog: {
        visible: false,
        message: '',
        valor: 0,
        width: '1000px',
      },
    }),

    created () {
      eventEmit.$on('show-dados-tabela', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('show-dados-tabela', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, area, redes, supervisor, classificacao, linhasProducao, produtos, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.produtos = produtos
        this.cidades = cidades

        this.showMargemRepresentante()
      },

      async showMargemRepresentante () {
        this.loading = true

        this.faturamentoGrupoProdutos = []
        this.expanded = []

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosVendedor = ''
        this.ordenacaoDadosVendedorDecrescente = false

        await AnaliseMargem.showAnaliseMargem2Representante(this.primeiroDia, this.ultimoDia, this.empresa, this.area, this.rede, this.supervisor, this.classificacao, this.linhasProducao, this.produtos, this.cidades, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoGrupoProdutos = resposta.data.dadosGrupoProdutos.map((item) => {
              var listaFaturamento = ({
                supervisor: item.nomeSupervisor,
                quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                margemPorcentagemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                quantidadeOrdenacao: parseFloat(item.quantidade),
                faturamentoOrdenacao: parseFloat(item.faturamento),
                volumeOrdenacao: parseFloat(item.volume),
                cmvOrdenacao: parseFloat(item.cmv),
                margemBrutaOrdenacao: parseFloat(item.margemBruta),
                margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
                margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
                expandir: item.expandir,
                dadosProduto: this.dadosProdutos(item.dadosProdutos),
              })

              return listaFaturamento
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            vendedor: item.nomeVendedor,
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            cmv: parseFloat(item.cmv).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemBruta: parseFloat(item.margemBruta).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            margemPorcentagemBruta: parseFloat(item.margemPorcentatemBruta).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            margemContribuicao: parseFloat(item.margemContribuicao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            prazoMedio: parseFloat(item.prazoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            dadosPrazo: item.dadosPrazoMedio,
            quantidadeOrdenacao: parseFloat(item.quantidade),
            faturamentoOrdenacao: parseFloat(item.faturamento),
            volumeOrdenacao: parseFloat(item.volume),
            cmvOrdenacao: parseFloat(item.cmv),
            margemBrutaOrdenacao: parseFloat(item.margemBruta),
            margemPorcentagemBrutaOrdenacao: parseFloat(item.margemPorcentatemBruta),
            margemContribuicaoOrdenacao: parseFloat(item.margemContribuicao),
            prazoMedioOrdenacao: parseFloat(item.prazoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos = novaOrdenacao
      },

      mudarOrdenacaoVendedores (campo, index) {
        if (campo === this.ordenarDadosVendedor) {
          this.ordenacaoDadosVendedorDecrescente = !this.ordenacaoDadosVendedorDecrescente
        } else {
          this.ordenarDadosVendedor = campo
          this.ordenacaoDadosVendedorDecrescente = false
        }

        this.ordenarDadosVendedores(index)
      },

      ordenarDadosVendedores (index) {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos[index].dadosProduto]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosVendedor] < b[this.ordenarDadosVendedor]) result = -1
          if (a[this.ordenarDadosVendedor] > b[this.ordenarDadosVendedor]) result = 1

          if (this.ordenacaoDadosVendedorDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos[index].dadosProduto = novaOrdenacao
      },

      detalheDadosPrazoMedio (dados) {
        this.ordenarDadosdetalhe = ''
        this.ordenacaoDadosDetalheDecrescente = false

        const vendedor = dados.vendedor.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')

        this.faturamentoVendedor = vendedor + ' - ' + dados.faturamento

        this.dadosDetalhe = dados.dadosPrazo.map((item) => {
          var participacao = (item.valor / dados.faturamentoOrdenacao) * 100

          var listaDados = ({
            id: item.id_opcao,
            opcaoPagamento: item.opcaoPagamento,
            faturamento: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            participacao: parseFloat(participacao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
            faturamentoOrdenacao: item.valor,
            participacaoOrdenacao: participacao,
          })

          return listaDados
        })

        this.showDialog(this.faturamentoVendedor)
      },

      mudarOrdenacaoDetalhe (campo) {
        if (this.ordenarDadosdetalhe === campo) {
          this.ordenacaoDadosDetalheDecrescente = !this.ordenacaoDadosDetalheDecrescente
        } else {
          this.ordenarDadosdetalhe = campo
          this.ordenacaoDadosDetalheDecrescente = false
        }

        this.buscarDadosOrdenadosDetalhe()
      },

      buscarDadosOrdenadosDetalhe () {
        const novaOrdenacao = [...this.dadosDetalhe]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosdetalhe] < b[this.ordenarDadosdetalhe]) result = -1
          if (a[this.ordenarDadosdetalhe] > b[this.ordenarDadosdetalhe]) result = 1

          if (this.ordenacaoDadosDetalheDecrescente) result *= -1

          return result
        })

        this.dadosDetalhe = novaOrdenacao
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.width = this.mobile ? '400px' : '1000px'
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #grupoProdutos {
      font-size: 10px;
      max-width: 100%
    }

    #idTable {
      max-height: 500px;
      max-width: 370px !important;
      /* margin: 0 0 0 -1rem; */
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }

    #tableExpandida {
      margin: 0 0rem 0 0rem;
      /* width: 95%; */
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #grupoProdutosId {
      width: 100%;
    }

    #grupoProdutos {
      font-size: 10px;
      max-width: 100%;
    }
  }
</style>

<style lang="sass">
  #grupoProdutos
    data-table-scroll-bar-width: 17px

  #tableExpandProduto
    margin: 0 0 0 2.5rem

</style>
